import { InjectionToken } from '@angular/core';

interface SidemenuItem {
  id?: string;
  link: string;
  name: string;
  icon: string;
  function: string | null;
  data: { roles: Array<string> };
}

interface SidemenuConfig {
  menuItems: SidemenuItem[];
  showIdentity: boolean;
}

export const SIDEMENU_CONFIG = new InjectionToken<SidemenuConfig>(
  'SIDEMENU_CONFIG',
);
